import React, { useState, useEffect } from "react";
import {
  Button,
  Typography,
  Grid,
  Container,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import api from "../../globals/axios";
import {
  CROP_TOKEN_TYPE_CONVENTION,
  getBlockchainNodeUrl,
} from "../../globals/const";
import CustomAppBar from "../../components/AppBar";
import { getFarmerFarms } from "../../api/farm";

export default function CreateClaim() {
  /* BLOCKCHAIN VARIABLES */
  const wallet = null;
  const [walletBalances, setWalletBalances] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  console.log("selectedFile", selectedFile);

  const [selectedDate, setSelectedDate] = useState(null);
  const [token, setToken] = useState("");

  //  Post Harvest Information
  const [formData, setFormData] = useState({
    title: "",
    description: "",
  });

  useEffect(() => {
    const loadFarms = async () => {
      const farms = await getFarmerFarms();
      if (farms && farms.length > 0) {
        const farmsToWalletBalances = farms.map((f) => {
          return { token_code: f.farm_name };
        });
        setWalletBalances(farmsToWalletBalances);
      }
    };

    loadFarms();
  }, []);

  useEffect(() => {
    api
      .get(
        getBlockchainNodeUrl() +
          "/get-balances?balance_type=ALL_TOKENS_IN_WALLET&wallet_address=" +
          wallet.address +
          "&token_type=" +
          CROP_TOKEN_TYPE_CONVENTION
      )
      .then((res) => res.data.balance)
      .then((data) => {
        if (data[0]) {
          setWalletBalances(data);
        }
      });
  }, [wallet]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);

    formData["land_token"] = token;
    formData["deadline"] = selectedDate;

    api
      .post("verification/add-verification-request/", formData)
      .then((response) => {
        console.log("POST request successful:", response.data);
        alert("Request added successfully!");
        setTimeout(() => {
          window.location.href = "/claims";
        }, 1000);
      })
      .catch((error) => {
        // Handle errors if the request fails
        console.error("Error making POST request:", error);
      });
  };

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <Grid
          container
          // spacing={1}
          justify="center"
          direction="column"
          style={{ marginTop: "10px" }}
        >
          <Typography variant="h5">Create Claim</Typography>
          <form onSubmit={handleSubmit} style={{ marginTop: "20px" }}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Title"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Description"
                  name="description"
                  multiline
                  rows={4}
                  value={formData.description}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth sx={{ marginTop: 2 }}>
                  <InputLabel id="token-select-label">Farmland/Crop</InputLabel>
                  <Select
                    labelId="token-select-label"
                    id="token-select"
                    value={token}
                    label="Token to send"
                    onChange={(e) => {
                      setToken(e.target.value);
                    }}
                  >
                    {walletBalances.map((b) => (
                      <MenuItem key={b.token_code} value={b.token_code}>
                        {b.token_code}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  id="date"
                  label="Due Date"
                  type="date"
                  value={selectedDate}
                  fullWidth
                  onChange={(e) => setSelectedDate(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <input type="file" onChange={setSelectedFile} />
              </Grid>

              <Grid item xs={12}>
                {/* <LocateLand
                      center={center}
                      setCenter={setUserCenter}
                      path={path}
                      setPath={setPath}
                      editable={true}
                    /> */}
              </Grid>

              <Grid mx="auto" item xs={6}>
                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  color="primary"
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Container>
    </>
  );
}
